module.exports = __webpack_public_path__ + "img/errorip.2b4d0f33.svg";